import { Component, input, OnInit, output } from '@angular/core'
import { FormsModule } from '@angular/forms'

interface Item {
  value: string
  label: string
}

@Component({
  imports: [FormsModule],
  selector: 'app-searchable-select',
  templateUrl: 'searchable-select.component.html',
  styleUrls: ['searchable-select.component.scss'],
})
export class SearchableSelectComponent implements OnInit {
  public items = input<Item[]>([])
  public value = input<string>('')
  public placeholder = input<string>('')
  public valueChange = output<string>()

  public isOpen = false
  public internalValue = ''
  public filteredItems: Item[] = []

  private filterItems(): void {
    if (!this.internalValue) {
      this.filteredItems = this.items()
      return
    }

    this.filteredItems = this.items().filter(item => {
      return (
        item.label.toLowerCase().startsWith(this.internalValue.toLowerCase()) ||
        item.value.toLowerCase().startsWith(this.internalValue.toLowerCase())
      )
    })
  }

  public onChange(value: string): void {
    this.isOpen = true
    this.internalValue = value
    this.filterItems()
    const matchingItem = this.filteredItems.find(item => item.label === value)

    if (matchingItem) {
      this.valueChange.emit(matchingItem.value)
    }
  }

  public select(item: Item): void {
    this.internalValue = item.value
    this.valueChange.emit(item.value)
    this.isOpen = false
  }

  ngOnInit(): void {
    this.internalValue = this.value()
    this.filteredItems = this.items()
  }
}
